<template>
  <AdminLayout>
    <h2 class="text-white mb-4" style="font-weight:800">Content Sections</h2>

    <div v-if="loading" class="text-silver">Loading sections...</div>

    <div v-else class="row g-3">
      <div v-for="block in sections" :key="block.section" class="col-md-6 col-lg-4">
        <div class="admin-card h-100 d-flex flex-column justify-content-between">
          <div>
            <h5 class="text-white text-capitalize mb-1">{{ labelFor(block.section) }}</h5>
            <p class="text-silver small mb-0">Last updated: {{ formatDate(block.updated_at) }}</p>
          </div>
          <RouterLink :to="'/admin/content/' + block.section" class="btn mt-3 d-block text-center">
            <span class="border-style">Edit</span>
          </RouterLink>
        </div>
      </div>
    </div>
  </AdminLayout>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import api from "@/services/api";
import AdminLayout from "@/components/admin/AdminLayout.vue";

const LABELS: Record<string, string> = {
  navigation:    "Navigation & Logo",
  footer:        "Footer",
  banner:        "Main Banner",
  who_we_are:    "Who We Are",
  features:      "Our Features",
  our_content:   "Our Content",
  favorite_match:"Favorite Match",
  test_service:  "Test Our Service",
  benefits:      "Only Benefits",
  testimonials:  "Testimonials",
  fan_facts:     "Fan Facts / Stats",
  movies_slider: "Movies Slider",
  faq:           "FAQ Page",
  pricing:       "Pricing Card Images",
  about:         "About Us Page",
  contact:       "Contact Us Page",
};

export default defineComponent({
  name: "ContentListPage",
  components: { AdminLayout },
  setup() {
    const sections = ref<any[]>([]);
    const loading = ref(true);

    onMounted(async () => {
      try {
        const { data } = await api.get("/api/admin/content");
        sections.value = data.data;
      } finally {
        loading.value = false;
      }
    });

    const labelFor = (section: string) => LABELS[section] || section.replace(/_/g, " ");
    const formatDate = (iso: string) => new Date(iso).toLocaleDateString();

    return { sections, loading, labelFor, formatDate };
  },
});
</script>

<style scoped>
.admin-card {
  background: #201516;
  border: 1px solid #3a2526;
  border-radius: 12px;
  padding: 1.5rem;
}
</style>
